import { postAction, getAction, putAction, deleteAction, downFile } from '@/api/manage'
import { axios } from '@/utils/request'

const BASE = '/api/plugin/gledger'

// 更新（PUT /资源/{id}）或创建（POST /资源），按是否携带 id 自动分流
const saveAction = (p, path) => (p && p.id != null ? putAction(`${BASE}/${path}/${p.id}`, p) : postAction(`${BASE}/${path}`, p))

// 账套
export const accountSetList = (p) => getAction(`${BASE}/account-sets`, p)
export const accountSetCreate = (p) => postAction(`${BASE}/account-sets`, p)
export const accountSetSetCurrent = (p) => putAction(`${BASE}/account-sets/${p.id}/current`)
export const accountSetSetBizLinked = (p) => putAction(`${BASE}/account-sets/${p.id}/biz-linked?linked=${p.linked}`)
export const accountSetCurrent = (p) => getAction(`${BASE}/account-sets/current`, p)
// 开账（业财一体账套：六维度业务期初写入余额体系，期初不进凭证流）
export const openAccountPreview = (p) => getAction(`${BASE}/account-set/open-account-preview`, p)
export const openAccountExecute = (p) => postAction(`${BASE}/account-set/open-account`, p)
export const openAccountRevoke = (p) => postAction(`${BASE}/account-set/open-account-revoke`, p)

// 科目
export const subjectTree = (p) => getAction(`${BASE}/subjects/tree`, p)
export const subjectLeafList = (p) => getAction(`${BASE}/subjects/leaf`, p)
export const subjectSave = (p) => saveAction(p, 'subjects')
export const subjectDelete = (p) => deleteAction(`${BASE}/subjects/${p.id}`)
export const subjectBindAuxFund = (p) => postAction(`${BASE}/subjects/bind-aux-fund`, p)
export const subjectBindList = (p) => getAction(`${BASE}/subjects/bind-list`, p)

// 凭证
export const voucherList = (p) => getAction(`${BASE}/vouchers`, p)
export const voucherGet = (p) => getAction(`${BASE}/vouchers/${p.id}`)
export const voucherSave = (p) => saveAction(p, 'vouchers')
export const voucherDelete = (p) => deleteAction(`${BASE}/vouchers/${p.id}`)
export const voucherStatus = (p) => putAction(`${BASE}/vouchers/${p.id}/status`, p)
export const voucherReverse = (p) => postAction(`${BASE}/vouchers/${p.id}/reverse`)

// 自动凭证
export const voucherAutoGenerate = (p) => postAction(`${BASE}/vouchers/auto-generate`, p)
export const voucherScanGenerate = (p) => postAction(`${BASE}/vouchers/scan-generate`, p)

// 账簿报表
export const ledgerSubjectBalance = (p) => getAction(`${BASE}/ledgers/subject-balance`, p)
// 总账（科目×月汇总分组：期初行 + 每月行 + 本年累计行）
export const ledgerGeneralLedger = (p) => getAction(`${BASE}/ledgers/general-ledger`, p)
export const ledgerAccountQuery = (p) => getAction(`${BASE}/ledgers/account-query`, p)
export const ledgerProfit = (p) => getAction(`${BASE}/ledgers/profit`, p)
export const ledgerBalanceSheet = (p) => getAction(`${BASE}/ledgers/balance-sheet`, p)
export const ledgerCashFlow = (p) => getAction(`${BASE}/ledgers/cash-flow`, p)
export const ledgerAuxBalance = (p) => getAction(`${BASE}/ledgers/aux-balance`, p)
export const ledgerAuxDetail = (p) => getAction(`${BASE}/ledgers/aux-detail`, p)

// 结账
export const closingClose = (p) => postAction(`${BASE}/closings`, p)
// 期末处理（结转·结账·反结账 + 试算平衡表 + 结转参数）
export const closingStatus = (p) => getAction(`${BASE}/closings/status`, p)
export const closingPreCheck = (p) => getAction(`${BASE}/closings/pre-check`, p)
export const closingReverse = (p) => postAction(`${BASE}/closings/reverse`, p)
export const closingCarryPreview = (p) => getAction(`${BASE}/closings/carry-preview`, p)
export const carryConfigList = (p) => getAction(`${BASE}/closings/carry-config`, p)
export const carryConfigSave = (p) => putAction(`${BASE}/closings/carry-config`, p)
export const carryConfigReset = (p) => postAction(`${BASE}/closings/carry-config/reset`, p)
export const carryTemplateList = (p) => getAction(`${BASE}/closings/carry-template`, p)
export const carryTemplateSave = (p) => putAction(`${BASE}/closings/carry-template`, p)
export const carryTemplateReset = (p) => postAction(`${BASE}/closings/carry-template/reset`, p)
// 试算平衡表（六列 + 三对合计校验）
export const trialBalance = (p) => getAction(`${BASE}/trial-balance`, p)

// 凭证字
export const voucherWordList = (p) => getAction(`${BASE}/voucher-words`, p)
export const voucherWordSave = (p) => saveAction(p, 'voucher-words')
export const voucherWordDelete = (p) => deleteAction(`${BASE}/voucher-words/${p.id}`)

// 辅助核算
export const auxiliaryCategoryList = (p) => getAction(`${BASE}/auxiliary-categories`, p)
export const auxiliaryCategorySave = (p) => saveAction(p, 'auxiliary-categories')
export const auxiliaryCategoryDelete = (p) => deleteAction(`${BASE}/auxiliary-categories/${p.id}`)
export const auxiliaryDetailList = (p) => getAction(`${BASE}/auxiliary-details`, p)
export const auxiliaryDetailSave = (p) => saveAction(p, 'auxiliary-details')
export const auxiliaryDetailDelete = (p) => deleteAction(`${BASE}/auxiliary-details/${p.id}`)

// 期初余额
export const initialBalanceList = (p) => getAction(`${BASE}/initial-balances`, p)
export const initialBalanceSave = (p) => saveAction(p, 'initial-balances')
export const initialBalanceDelete = (p) => deleteAction(`${BASE}/initial-balances/${p.id}`)

// 币别
export const currencyList = (p) => getAction(`${BASE}/currencies`, p)
export const currencySave = (p) => saveAction(p, 'currencies')
export const currencyDelete = (p) => deleteAction(`${BASE}/currencies/${p.id}`)

// 凭证主从列表/查询（GET：year/month/page/pageSize/筛选全走 query string）
export const voucherListPage = (p) => getAction(`${BASE}/vouchers/page`, p)
// 凭证操作
export const voucherAudit = (p) => putAction(`${BASE}/vouchers/${p.id}/audit`)
export const voucherUnAudit = (p) => putAction(`${BASE}/vouchers/${p.id}/un-audit`)
// 凭证提交审核（发起审批流程，bigType=3 由 workflow-plugin 回写凭证状态 9）
export const voucherSubmitAudit = (voucherNo) => postAction('/api/plugin/workflow/workflowTask/add', { bigType: 3, billNo: voucherNo })
// 撤回审核：审核中(9) → 未审核(0)，终止流程实例
export const voucherCancelAudit = (p) => putAction(`${BASE}/vouchers/${p.id}/cancel-audit`)
export const voucherBatchDelete = (p) => deleteAction(`${BASE}/vouchers/batch`, { ids: Array.isArray(p.ids) ? p.ids.join(',') : p.ids })
export const voucherRenumber = (p) => postAction(`${BASE}/vouchers/renumber`, p)
export const voucherCopy = (p) => postAction(`${BASE}/vouchers/${p.id}/copy`)

// 凭证导出（GET blob，参数同 voucherListPage）
export const voucherExport = (p) => downFile(`${BASE}/vouchers/export`, p)
// 导入模板：GET blob
export const voucherImportTemplate = () => axios({
  url: `${BASE}/vouchers/import-template`,
  method: 'get',
  responseType: 'blob'
})
// 导入凭证：FormData 上传 .xls
export const voucherImportFile = (formData) => axios({
  url: `${BASE}/vouchers/import`,
  method: 'post',
  data: formData,
  headers: { 'Content-Type': 'multipart/form-data' }
})

// 业务模板规则
export const ruleList = (p) => getAction(`${BASE}/rules`, p)
export const ruleDefault = (p) => getAction(`${BASE}/rules/default`, p)
export const ruleImportFromDefault = (p) => postAction(`${BASE}/rules/import-from-default`, p)
export const ruleSave = (p) => saveAction(p, 'rules')
export const ruleDelete = (p) => deleteAction(`${BASE}/rules/${p.id}`)
export const ruleRestore = (p) => postAction(`${BASE}/rules/restore`, p)

// 结算账户→科目映射（方案A：jsh_gl_account_subject 归一化 1001/1002/1012）
export const accountSubjectList = (p) => getAction(`${BASE}/account-subjects`, p)
export const accountSubjectSave = (p) => saveAction(p, 'account-subjects')
export const accountSubjectDelete = (p) => deleteAction(`${BASE}/account-subjects/${p.id}`)
export const accountSubjectSync = (p) => postAction(`${BASE}/account-subjects/sync`, p)
// 账户→一级科目绑定校验 + 批量应用（T4-1 方案A）
export const accountSubjectBindCheck = (p) => postAction(`${BASE}/account-subjects/bind-check`, p)
export const accountSubjectApplyBindBatch = (p) => postAction(`${BASE}/account-subjects/apply-bind-batch`, p)

// ====================================================================
// T9 新增 18 方法（FinAccount 5 / MdRegister 5 / FeeAdjust 3 / PayCallbackLog 1 / 绑定扩展 4）
// ====================================================================

// 资金账户档案（T10 FinAccountList.vue · 启用手续费/支付扩展配置/快捷转账）
export const finAccountList = (p) => getAction(`${BASE}/fin-accounts`, p)
export const finAccountSaveExt = (p) => postAction(`${BASE}/fin-accounts/ext`, p)
export const finAccountToggleEnabled = (p) => putAction(`${BASE}/fin-accounts/${p.id}/enabled`)
export const finAccountQuickTransfer = (p) => postAction(`${BASE}/fin-accounts/quick-transfer`, p)
export const finAccountSubjectBindOptions = (p) => getAction(`${BASE}/fin-accounts/subject-bind-options`, p)

// 主数据注册（T11 MdRegisterList.vue · 系统型辅助核算来源/Z模式租户副本）
export const mdRegisterList = (p) => getAction(`${BASE}/md-registers`, p)
export const mdRegisterCopyFromSystem = (p) => postAction(`${BASE}/md-registers/copy-from-system`, p)
export const mdRegisterSave = (p) => saveAction(p, 'md-registers')
export const mdRegisterDelete = (p) => deleteAction(`${BASE}/md-registers/${p.id}`)
export const mdRegisterRestorePreset = (p) => postAction(`${BASE}/md-registers/restore-preset`, p)

// 手续费调整（T6 8场景计算 + PENDING 凭证生成）
export const feeAdjustBatchCalc = (p) => postAction(`${BASE}/fee-adjusts/batch-calc`, p)
export const feeAdjustList = (p) => getAction(`${BASE}/fee-adjusts`, p)
export const feeAdjustGenerateVoucher = (p) => postAction(`${BASE}/fee-adjusts/generate-voucher`, p)

// 支付回调日志（T12 PaymentCallbackLogList.vue · 三方对账/错误排查）
export const payCallbackLogList = (p) => getAction(`${BASE}/pay-callback-logs`, p)

// 业务凭证
export const businessVoucherPending = (p) => getAction(`${BASE}/business-vouchers/pending-docs`, p)
export const businessVoucherGenerate = (p) => postAction(`${BASE}/business-vouchers/generate`, p)
export const businessVoucherSourceBill = (p) => getAction(`${BASE}/business-vouchers/${p.sourceId}/source-bill`, { sourceType: p.sourceType })

// 票据类型映射（凭证规则模板驱动）
export const billMappingList = (p) => getAction(`${BASE}/bill-mappings`, p)
export const billMappingSave = (p) => saveAction(p, 'bill-mappings')
export const billMappingDelete = (p) => deleteAction(`${BASE}/bill-mappings/${p.id}`)

// 辅助字段映射（凭证规则模板驱动）
export const auxFieldMapList = (p) => getAction(`${BASE}/aux-field-maps`, p)
export const auxFieldMapSave = (p) => saveAction(p, 'aux-field-maps')
export const auxFieldMapDelete = (p) => deleteAction(`${BASE}/aux-field-maps/${p.id}`)

// 现金流映射规则（凭证规则 Tab4；列表含系统模板行 isTemplate=1 在前）
export const cashFlowRuleList = (p) => getAction(`${BASE}/cash-flow-rules`, p)
export const cashFlowRuleSave = (p) => saveAction(p, 'cash-flow-rules')
export const cashFlowRuleDelete = (p) => deleteAction(`${BASE}/cash-flow-rules/${p.id}`)
// 现金流项目智能候选（matched=规则命中推荐 + groups=全量项目分组）
export const cashFlowCandidates = (p) => getAction(`${BASE}/cash-flows/candidates`, p)
// 历史凭证现金流标签补录（对未打标资金分录按规则补插标签，幂等）
export const cashFlowBackfillTags = (p) => postAction(`${BASE}/cash-flows/backfill-tags`, p)

// ==================== 报表公式引擎（三大报表统一计算 + 数据项/公式维护） ====================
// 现金流量表补充资料（间接法）计算：{accountSetId, period} → {meta, rows, checks}
export const ledgerCashFlowSupp = (p) => getAction(`${BASE}/ledgers/cash-flow-supp`, p)
// 报表数据项（平铺树：账套行优先+模板行补缺，含 parentId/parentName）
export const reportItemTree = (p) => getAction(`${BASE}/report-items/tree`, p)
export const reportItemSave = (p) => saveAction(p, 'report-items')
export const reportItemDelete = (p) => deleteAction(`${BASE}/report-items/${p.id}`)
// 报表取数公式（表外公式明细行，按数据项 itemId 维护）
export const reportFormulaList = (p) => getAction(`${BASE}/report-formulas`, p)
export const reportFormulaSave = (p) => saveAction(p, 'report-formulas')
export const reportFormulaDelete = (p) => deleteAction(`${BASE}/report-formulas/${p.id}`)
